import React, { useEffect, useState } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import {
  getAdaptiveLearningContent,
  getAdaptiveLearningTest,
} from "../helper/apicalls/adaptiveLearning";
import Content from "../components/Content";
import GlobalLoader from "../components/GlobalLoader";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import StartTestCard from "../components/StartTestCard";
import TestResults from "../components/TestResults";

const AdaptiveShowContent = () => {
  const { id, mode } = useParams();
  const navigate = useNavigate();
  const location = useLocation();

  const [loading, setLoading] = useState(false);
  const [contentData, setContentData] = useState(null);
  const [error, setError] = useState(null);
  const [isMarkAsComplete, setIsMarkAsComplete] = useState(false);
  const [testData, setTestData] = useState(null);
  const topicMeta = location.state;

  useEffect(() => {
    fetchContent(mode);
  }, [mode]);

  const fetchContent = async (mode) => {
    try {
      setLoading(true);
      if (mode === "content") {
        const response = await getAdaptiveLearningContent(id);
        setContentData(response?.content || []);
      } else {
        const response = await getAdaptiveLearningTest(id);
        setTestData(response);
      }
    } catch (e) {
      setError("Failed to load content");
    } finally {
      setLoading(false);
    }
  };

  const getBreadcrumbPath = (learningContext = {}) => {
    const sequence = ["course", "subject", "topic", "subtopic"];
    return sequence
      .map((key) => {
        const node = learningContext[key];
        if (!node) return null;
        return node.name || node.title || node.display_name;
      })
      .filter(Boolean)
      .join(" > ");
  };

  const handleTestClick = () => {
    if (!testData) return;

    navigate(`/test/${id}`, {
      state: {
        topicId: id,
        data: testData.mcq || [],
        isAdaptiveTest: true,
      },
    });
  };

  const cleanMarkdownContent = (contentArr = []) => {
    if (!Array.isArray(contentArr) || !contentArr.length) return contentArr;

    return [
      {
        ...contentArr[0],
        content: contentArr[0].content.replace(
          /^```(?:markdown)?\s*|\s*```$/g,
          "",
        ),
      },
      ...contentArr.slice(1),
    ];
  };

  if (loading) return <GlobalLoader />;

  if (error) return <p>{error}</p>;

  const handleShowTestAnswers = () => {
    if (!id) return;
    navigate(`/test/${id}?review=true`, {
      state: {
        topicId: id,
        data: testData.questions || [],
        isAdaptiveTest: true,
      },
    });
  };

  return (
    <div className="adaptive-learning-content-view custom-scrollbar">
      <div className="detail-header">
        <div className="header-content">
          <ArrowBackIcon
            className="back-icon"
            onClick={() => navigate(-1)}
            style={{ cursor: "pointer" }}
          />
          <h1 className="detail-title">
            {topicMeta?.learning_context
              ? getBreadcrumbPath(topicMeta.learning_context)
              : mode === "content"
                ? "Adaptive Learning Content"
                : "Adaptive Learning Test"}
          </h1>
        </div>
      </div>

      <div className="detail-scroll-container">
        {mode === "content" && (
          <Content
            content={cleanMarkdownContent(contentData)}
            isMarkAsComplete={isMarkAsComplete}
            setIsMarkAsComplete={setIsMarkAsComplete}
          />
        )}

        {mode === "test" && !testData?.completed && (
          <StartTestCard
            adaptiveId={id}
            totalQuestions={testData?.total_questions}
            durationMinutes={testData?.time_required}
            onStart={handleTestClick}
          />
        )}
        {mode === "test" && testData?.completed && (
          <TestResults
            score={testData?.no_of_question_correct}
            totalQuestions={testData?.total_questions}
            userData={testData?.answers}
            questions={testData?.questions}
            onShowAnswer={handleShowTestAnswers}
            pageId={id}
            pageKey={mode}
            pageTitle="adaptive_test"
          />
        )}
      </div>
    </div>
  );
};

export default AdaptiveShowContent;
